// extracted by mini-css-extract-plugin
module.exports = {"context":"context_context__fp4zE","image":"context_image__1C2F_","text":"context_text__3F-jT"};